// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Hx9W","errorLogs":"EditorFooter_errorLogs__3Va6H"};